import { useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { CenteredPageShell } from '../components/core/layout/CenteredPageShell';
import { NotFoundHero } from '../components/core/common/feedback/NotFoundHero';

/**
 * The `*` catch-all.
 *
 * `routes.tsx` renders this bare — no guard, no `AppLayout`, no `PageBoundary`,
 * unlike every other route — so the page picks its own chrome from `user`. Both
 * halves of that are now named components: `CenteredPageShell` chooses the
 * chrome, `NotFoundHero` draws the screen. What is left here is the only part
 * that is genuinely this route's own — reading the auth state and deciding
 * where "home" points for a visitor who may not have one.
 */
export function NotFoundPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const signedIn = !!user;

  return (
    <CenteredPageShell signedIn={signedIn}>
      <NotFoundHero
        signedIn={signedIn}
        onHome={() => navigate(signedIn ? '/' : '/auth')}
      />
    </CenteredPageShell>
  );
}
